import { Check, ContentCopy } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { rem } from 'polished';
import { useState } from 'react';
import * as buttonStyles from '~/elements/Buttons/Button.css';
import { useTheme } from '~/utils/store';
import { tooltipSlotProps } from '../Tooltip';

const CopyToClipboard = ({
  text,
  copyStyle,
  checkStyle,
  containerStyle,
}: {
  text: string | undefined;
  copyStyle?: React.CSSProperties;
  checkStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}) => {
  const [copied, setCopied] = useState(false);
  const theme = useTheme();

  const handleCopy = () => {
    if (!text || copied) return;
    if (!navigator.clipboard) return; // requires a secure origin or localhost
    void navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Tooltip arrow open={copied} title="Copied!" slotProps={tooltipSlotProps}>
      {/* Required for tooltip forwardRef */}
      <button
        type="button"
        className={buttonStyles.buttonCircular}
        style={{
          display: 'inline-flex',
          width: 34,
          height: 34,
          ...containerStyle,
        }}
        onClick={handleCopy}
      >
        {copied ? (
          <Check
            style={{
              color: '#4CAF50',
              fontSize: 19,
              ...checkStyle,
            }}
          />
        ) : (
          <ContentCopy
            style={{
              fontSize: '1.1rem',
              cursor: 'pointer',
              color: theme === 'light' ? '#7d7d7d' : '#fff',
              ...copyStyle,
            }}
          />
        )}
      </button>
    </Tooltip>
  );
};

/** The multiple wiki copy button */
export const CopyToClipBoardButton = ({ disabled, text }: { disabled?: boolean; text: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!text || copied) return;
    if (!navigator.clipboard) return; // requires a secure origin or localhost
    void navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={buttonStyles.primaryWithIcon}
      disabled={disabled}
      style={{
        minWidth: 132,
      }}
    >
      {copied ? (
        <Check
          style={{
            color: '#fff',
            fontSize: 20,
            marginLeft: -5,
          }}
        />
      ) : (
        <ContentCopy
          style={{
            fontSize: rem(17),
            marginTop: 2,
          }}
        />
      )}
      {copied ? <span>Copied! &nbsp;</span> : 'Copy link'}
    </button>
  );
};

export default CopyToClipboard;
